<template>
  <div class="flex h-auto bg-lightgrey">
    <div v-if="ui.processing" class="h-screen flex w-full">
      <div class="m-auto">
        <p class="text-5xl font-light">{{ ui.message || "Loading" }}</p>
        <img
          class="m-auto mt-8 w-1/6"
          src="../assets/svg/three-dots.svg"
          alt="Loader"
        />
      </div>
    </div>
    <div v-else class="py-10 w-3/4 mx-auto">
      <div class="flex items-center justify-between mb-4">
        <div>
          <p class="font-semibold tracking-wider text-gray-500 text-sm">
            Related to {{ this.fields.dealName }}
          </p>
          <p v-if="quotes.length > 0" class="mb-4 text-3xl font-semibold">
            Quotes
          </p>
          <p v-else class="mb-4 text-2xl font-semibold tracking-widest">
            No existing Quotes found.
          </p>
        </div>
        <div>
          <button
            @click.prevent="newQuote()"
            class="bg-primary px-8 py-4 shadow rounded transition-all duration-500 ease-in-out transform hover:scale-95"
          >
            <p class="text-white leading-none">Create Quote</p>
          </button>
        </div>
      </div>
      <div class="w-full grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-10">
        <div
          v-for="quote in quotes"
          :key="quote.id"
          @click.prevent="goToForm(quote.id)"
          class="bg-white border border-gray-200 rounded shadow-md transition-all duration-500 ease-in-out transform hover:scale-105 hover:cursor-pointer"
        >
          <div class="p-4">
            <div class="w-full mb-6 flex items-center justify-between">
              <div class="text-gray-700 font-bold text-xl">
                {{ quote.account_name }}
              </div>
              <!--
              <button class="bg-primary rounded">
                <p class="text-white text-xs px-4 py-2 leading-none">Open</p>
              </button>
              -->
            </div>
            <div class="p-6 mb-6 border-dashed border-2 rounded">
              <div class="grid grid-cols-2 gap-8">
                <div>
                  <p class="text-gray-500 font-semibold text-xs">Contact</p>
                  <p class="text-gray-700 font-semibold">
                    {{ quote.contact.first_name }} {{ quote.contact.last_name }}
                  </p>
                </div>
                <div>
                  <p class="text-gray-500 font-semibold text-xs">Type</p>
                  <p class="text-gray-700 font-semibold">
                    {{ quote.type }}
                  </p>
                </div>
                <div>
                  <p class="text-gray-500 font-semibold text-xs">Total</p>
                  <p class="text-gray-700 font-semibold">
                    $ {{ totalize(quote.line_items) }}
                  </p>
                </div>
                <div>
                  <p class="text-gray-500 font-semibold text-xs">Date</p>
                  <p class="text-gray-700 font-semibold">
                    {{ formatDate(quote.created_at, "MMMM D YYYY") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="flex items-center justify-between">
              <p class="text-gray-500 text-xs font-semibold">By Administrator</p>
              <div v-if="quote.status == 'Saved'" class="bg-yellow-700 text-white rounded-full px-2 py-1 text-xs font-semibold">Saved in Zoho CRM</div>
              <div v-if="quote.status == 'Draft'" class="bg-green-500 text-white rounded-full px-2 py-1 text-xs font-semibold">In Progress</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric, email, maxLength } from "vuelidate/lib/validators";
import { createContact, createQuote, searchQuotes } from "~/api";
import { API_URL } from "~/.env";

export default {
  name: "ProcessPage",

  data() {
    return {
      ui: {
        processing: false,
        loading: false,
        success: true,
        message: null,
        error: false
      },

      fields: {
        dealId: null,
        dealName: null,
        type: null,
        ownerId: null,
        ownerName: null,
        accountId: null,
        accountName: null,
        billingStreet: null,
        billingCity: null,
        billingState: null,
        billingZip: null,
        billingCountry: null,
        contactId: null,
        contactFirstName: null,
        contactLastName: null,
        contactEmail: null,
        termsConditions: null,
      },

      quotes: [],

      form: {
        contactId: null,
        quoteId: null
      }
    };
  },

  validations: {
    fields: {
      dealId: {
        required,
        numeric,
        maxLength: maxLength(20)
      },
      dealName: {
        required,
        maxLength: maxLength(100)
      },
      type: {
        required,
        maxLength: maxLength(20)
      },
      ownerId: {
        required,
        numeric,
        maxLength: maxLength(20)
      },
      ownerName: {
        required,
        maxLength: maxLength(100)
      },
      accountId: {
        required,
        numeric,
        maxLength: maxLength(20)
      },
      accountName: {
        required,
        maxLength: maxLength(100)
      },
      billingStreet: {
        maxLength: maxLength(250)
      },
      billingCity: {
        maxLength: maxLength(30)
      },
      billingState: {
        maxLength: maxLength(30)
      },
      billingZip: {
        maxLength: maxLength(10)
      },
      billingCountry: {
        maxLength: maxLength(50)
      },
      contactId: {
        required,
        //numeric,
        maxLength: maxLength(20)
      },
      contactFirstName: {
        maxLength: maxLength(100)
      },
      contactLastName: {
        required,
        maxLength: maxLength(100)
      },
      contactEmail: {
        required,
        email,
        maxLength: maxLength(50)
      }
    }
  },

  mounted() {
    this.process();
  },

  methods: {
    formatDate(date, format) {
      return window.moment(date).format(format);
    },

    totalize(items) {
      let total = _.sumBy(items, item => {
        if (item.active) {
          let subtotal = parseInt(item.quantity) * parseFloat(item.unit_price);
          let discount = (subtotal * parseFloat(item.discount)) / 100;
          return subtotal - discount;
        }
        return 0;
      });

      return window.numeral(total).format("0.00a");
    },

    async process() {
      try {
        this.ui.processing = true;
        await this.set();
        await this.validate();
        await this.searchQuotes();
        setTimeout(() => {
          this.ui.processing = false;
        }, 5000);
        //await this.createContact();
        //await this.createQuote();
        //await this.goToForm();
      } catch (e) {
        console.error(e);
      }
    },

    set() {
      return new Promise(resolve => {
        this.fields.dealId = this.$route.query.deal_id;
        this.fields.dealName = this.$route.query.deal_name;
        this.fields.type = this.$route.query.type;
        this.fields.ownerId = this.$route.query.owner_id;
        this.fields.ownerName = this.$route.query.owner_name;
        this.fields.accountId = this.$route.query.account_id;
        this.fields.accountName = this.$route.query.account_name;
        this.fields.billingStreet = decodeURI(this.$route.query.billing_street);
        this.fields.billingCity = this.$route.query.billing_city;
        this.fields.billingState = this.$route.query.billing_state;
        this.fields.billingZip = this.$route.query.billing_zip;
        this.fields.billingCountry = this.$route.query.billing_country;
        this.fields.contactId = this.$route.query.contact_id;
        this.fields.contactFirstName = this.$route.query.contact_first_name;
        this.fields.contactLastName = this.$route.query.contact_last_name;
        this.fields.contactEmail = this.$route.query.contact_email;
        this.fields.termsConditions = "All orders are subject to acceptance. \nDue to export regulations, country of end destination must be state at time of purchase. In addition to the above provisions, the General Terms and Conditions of Koehler Instrument Company, Inc. apply to all orders unless declared otherwise by Koehler Instrument Company and can be found at: https://koehlerinstrument.com/terms-and-conditions/";
        console.log(this.fields);
        resolve();
      });
    },

    validate() {
      return new Promise((resolve, reject) => {
        this.$v.fields.$touch();
        if (this.$v.fields.$invalid) {
          let fields = _.keys(this.fields);
          let validationHtml = '<ul>';

          fields.forEach(field => {
            let validatedField = this.$v.fields[field];
            if (validatedField.$invalid) {
              validationHtml += '<li><b>- The ';
              validationHtml += _.startCase(field);
              if (validatedField.required == false) {
                validationHtml += " cannot be empty";
              } else if (validatedField.maxLength == false) {
                validationHtml += " must not exceed " + validatedField.$params.maxLength.max + " characters";
              }
              validationHtml += '.</b></li>';
            }
          });
          console.log('validated', this.$v.fields, fields);
          validationHtml += '</ul>';
          validationHtml += '<small>You can review fields in their respective CRM record</small>';
          validationHtml += '<ul>';
          validationHtml += '<li><small>- The Account Id, Account Name, Billing Street, Billing City, Billing State, Billing Zip and Billing Country corresponds to the Account record.</small></li>';
          validationHtml += '<li><small>- The Deal Id, Deal Name and Type corresponds to the Deal record.</small></li>';
          validationHtml += '<li><small>- The Contact Id, Contact First Name, Contact Last Name and Contact Email corresponds to the Contact record.</small></li>';
          validationHtml += '</ul>';
          window.SwalError.fire({
            title: 'Validation',
            html: '<p>Please review and fix the following fields:</p>' + validationHtml,
          });
          reject("validate");
        } else {
          resolve();
        }
      });
    },

    searchQuotes() {
      return new Promise((resolve, reject) => {
        this.ui.loading = true;
        this.ui.success = false;
        this.ui.error = false;
        this.ui.message = "Searching Quotes";

        searchQuotes({
          field: "zcrm_deal_id",
          value: this.fields.dealId
        })
          .then(response => {
            if (response.length > 0) {
              this.quotes = response;
            }

            this.ui.loading = false;
            this.ui.success = true;

            setTimeout(() => {
              resolve();
            }, 3000);
          })
          .catch(error => {
            this.ui.error = true;
            reject(error);
          });
      });
    },

    async newQuote() {
      try {
        this.ui.processing = true;
        await this.createContact();
        await this.createQuote();
        await this.goToForm();
        setTimeout(() => {
          this.ui.processing = false;
        }, 5000);
      } catch (e) {
        console.error(e);
      }
    },

    async createContact() {
      return new Promise((resolve, reject) => {
        this.ui.loading = true;
        this.ui.success = false;
        this.ui.error = false;
        this.ui.message = "Creating Contact";

        createContact({
          zcrm_id: this.fields.contactId,
          first_name: this.fields.contactFirstName,
          last_name: this.fields.contactLastName,
          email: this.fields.contactEmail
        })
          .then(response => {
            if (response.id) {
              this.form.contactId = response.id;

              this.ui.loading = false;
              this.ui.success = true;

              setTimeout(() => {
                resolve();
              }, 3000);
            } else {
              throw new Error(
                "There was a problem trying to create the Contact."
              );
            }
          })
          .catch(error => {
            this.ui.error = true;

            reject(error);
          });
      });
    },

    async createQuote() {
      return new Promise((resolve, reject) => {
        this.ui.loading = true;
        this.ui.success = false;
        this.ui.error = false;
        this.ui.message = "Creating Draft Quote";

        createQuote({
          deal_id: this.fields.dealId,
          deal_name: this.fields.dealName,
          type: this.fields.type,
          contact_id: this.form.contactId,
          owner_id: this.fields.ownerId,
          owner_name: this.fields.ownerName,
          account_id: this.fields.accountId,
          account_name: this.fields.accountName,
          billing_street: this.fields.billingStreet && this.fields.billingStreet != "null"
            ? this.fields.billingStreet
            : "",
          billing_city: this.fields.billingCity && this.fields.billingCity != "null" ? this.fields.billingCity : "",
          billing_state: this.fields.billingState && this.fields.billingState != "null" ? this.fields.billingState : "",
          billing_zip: this.fields.billingZip && this.fields.billingZip != "null" ? this.fields.billingZip : "",
          billing_country: this.fields.billingCountry && this.fields.billingCountry != "null" ? this.fields.billingCountry : "",
          status: "Draft",
          terms_conditions: this.fields.termsConditions,
        })
          .then(response => {
            if (response.id) {
              this.form.quoteId = response.id;

              this.ui.loading = false;
              this.ui.success = true;

              setTimeout(() => {
                resolve();
              }, 3000);
            } else {
              throw new Error(
                "There was a problem trying to create the Quote."
              );
            }
          })
          .catch(error => {
            this.ui.error = true;

            reject(error);
          });
      });
    },

    goToForm(quoteId) {
      this.ui.processing = true;
      this.ui.message = "Opening Form";

      if (!quoteId) {
        quoteId = this.form.quoteId;
      }

      setTimeout(() => {
        this.$router.push({
          name: "quote.customer",
          params: { id: quoteId }
        });
      }, 3000);
    },

    pdfURL(quoteId) {
      return `${API_URL}/api/v1/quotes/${quoteId}/pdf`;
    }
  }
};
</script>
